import jwt_decode from "jwt-decode";

import { refreshIdentity } from "@api/auth/refreshIdentity";
import { ACCESS_TOKEN_KEY, EXPIRES_AT_KEY, ORGANIZATION_KEY } from "@constants";
import { recoverBrowserSecurityError } from "@utils/storage";

export const refreshUserAuth = async (): Promise<void> => {
  // post code to backend and do auth there;
  const { token } = await refreshIdentity();

  // save bearer token from backend to localStorage
  const decoded = jwt_decode<any>(token);
  recoverBrowserSecurityError(() => {
    // make sure to invalidate cache first
    localStorage.removeItem(ORGANIZATION_KEY);
    // then replace with new login token
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
    localStorage.setItem(EXPIRES_AT_KEY, JSON.stringify(decoded.exp * 1000));
  });
};
